import * as THREE from "three";
// import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { FBXLoader } from "./FBXLoader";

import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { BehaviorSubject } from "rxjs";
// import { check } from "../../utils/entity-checker";

class AssetManager {
  loadingManager;

  constructor(world) {
    this.loading = false;
    this.world = world;
    this.assets = {};
    this.assets$ = {};
    this.initializeLoadingManager();
  }

  initializeLoadingManager() {
    const fbxLoader = new FBXLoader();

    this.loadingManager = THREE.DefaultLoadingManager;
    this.loadingManager.addHandler(/.fbx$/i, fbxLoader);
    this.loadingManager.addHandler(/.gltf$/i, new GLTFLoader());
    this.loadingManager.addHandler(/.jpg|.png$/i, new THREE.TextureLoader());
    this.loadingManager.onStart = () => {
      this.world.store.dispatch({ type: "three/setLoading", payload: true });
      this.loading = true;
    };
    this.loadingManager.onLoad = () => {
      // if FBXLoader is still parsing data, wait ...
      if (fbxLoader.parsing) {
        fbxLoader.onParse = () => {
          this.world.store.dispatch({
            type: "three/setLoading",
            payload: false,
          });
          this.world.store.dispatch({ type: "three/setLoaded", payload: true });
          this.loading = false;
          this.world.change$.next();
        };
      } else {
        this.world.store.dispatch({ type: "three/setLoading", payload: false });
        this.world.store.dispatch({ type: "three/setLoaded", payload: true });
        this.loading = false;
        this.world.change$.next();
      }
    };
    this.loadingManager.onProgress = (item, loaded, total) => {
      this.world.store.dispatch({
        type: "three/setLoadingProgress",
        payload: loaded / total,
      });
    };
  }

  getAsset(id) {
    return this.assets[id];
  }

  setAsset(id, asset) {
    this.assets[id] = asset;
    const asset$ = this.getAsset$(id);
    if (asset) {
      if (asset.hasOwnProperty("name") && asset.name === "") {
        asset.name = id;
      }
      asset$.next(asset);
    } else {
      console.log("TODO: dispose asset, complete stream, etc ...");
    }
  }

  getAsset$(url) {
    if (!this.assets$[url]) {
      const asset$ = (this.assets$[url] = new BehaviorSubject());

      const loader = this.loadingManager.getHandler(url);

      if (loader) {
        const onLoad = (asset) => {
          this.setAsset(url, asset);
        };
        const onProgress = () => {};
        const onError = (error) => {
          asset$.error(error);
        };

        loader.load(url, onLoad, onProgress, onError);
      }
    }
    return this.assets$[url];
  }
}

export default AssetManager;
